/* ==================== */
/* グループ選択モーダル */
/* ==================== */
import React, { useEffect, useState } from 'react';
import Loading from '../Loading/Loading';
import Modal from '../Modal/Modal';
import { MODAL_TYPE, RESPONSE } from '../../const/Enum';
import { requestApiLoad } from '../../utils/apiLoadUtil';
import './SelectMultGroupModal.css';

const SelectMultGroupModal = ({ isOpen, setIsOpen, setSelectGroups, selectGroups }) => {
  const [groupList, setGroupList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const fetchData = async () => {
        const res = await requestApiLoad('/staffGroup/get', {}, setIsLoading);
        if (res.return !== RESPONSE.SUCCESS) {
          return;
        }
        setGroupList(res.groupList.map(group => ({
          ...group,
          isSelect: selectGroups.some(selectedGroup => selectedGroup.groupId === group.groupId)
        })));
      }
      fetchData();
    }
  }, [isOpen, selectGroups]);

  useEffect(() => {
    if (groupList.length > 0) {
      setGroupList(prevList => 
        prevList.map(group => ({
          ...group,
          isSelect: selectGroups.some(selectedGroup => selectedGroup.groupId === group.groupId)
        }))
      );
    }
    // eslint-disable-next-line
  }, [selectGroups]);

  const onSelectGroup = (item) => {
    setGroupList(prevList =>
      prevList.map(group => 
        group.groupId === item.groupId
          ? { ...group, isSelect: !group.isSelect }
          : group
      )
    );
  };

  const handleSubmit = () => {
    const selectedGroups = groupList.filter(group => group.isSelect);
    setSelectGroups(selectedGroups);
    setIsOpen(false);
  }
  
  return (   
    <Modal
      title="グループ選択"
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      actionButtonText="OK"
      onAction={handleSubmit}
      playerKey={MODAL_TYPE.SELECT}
      id="select-groups-modal"
    >
      <div className="select-groups-modal">
        <Loading isLoading={isLoading} />
      
        <div className="card-list" id="modal-card-list">
          {groupList.length === 0 ? (
            <div className="no-data">データがありません</div>
          ) : (
            groupList.map((item) => (
              <div
                className="card"
                key={item.groupId}
                onClick={() => onSelectGroup(item)}
              >
                <div className="card-contents">
                  <div style={{ width: '20px', height: '20px', marginRight: '10px' }}>
                    {item.isSelect && (
                      <svg
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        height="20px"
                        viewBox="0 0 24 24"
                        aria-labelledby="okIconTitle"
                        stroke="#007bff"
                        strokeWidth="2.4"
                        strokeLinecap="square"
                        strokeLinejoin="miter"
                        fill="none"
                        color="#007bff"
                      >
                        <title id="okIconTitle">OK</title>
                        <polyline points="4 13 9 18 20 7" />
                      </svg>
                    )}
                  </div>

                  <div className="card-contents-left">
                    <h3>{item.groupName}</h3>
                    <span className="sub-text">所属人数：{item.parsonCount} 人</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SelectMultGroupModal;